const BLACKLIST_DOMAINS = ['elastic.co'];

export const isAllowedToAddHeaders = url => !BLACKLIST_DOMAINS.filter(domain => url.includes(domain)).length;
